export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-18.jpg'),
        title: 'NETWORK SECURITY',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'NETWORK SECURITY IS CRITICAL TO BUSINESS OPERATIONS',
      description: `<p style="font-size:1.5rem">In the Internet age, network security is critical to business operations. In order to protect the hardware, software
and data of your network system from being damaged, altered or leaked by accidental or malicious reasons,
security systems run continuously, reliably and normally,
so that the network service will not be interrupted. </p>
<p>MaesInfo has first-class Java engineers and senior software development engineers, and also Cisco,
CCIE network experts, aiming to provide you with perfect professional services,
computer software security, operation service security, data security, etc.,.</p>`
    },
    {
      title: 'FOR NETWORK SECURITY, MAESINFO CAN:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-18.jpg')+`)"></span>
      <span class="list">
      <i></i>Develop and upgrade network security protection software<br/>
      <i></i>Update and upgrade security protection systems to prevent <br/>
      <i></i>data leakage and damage

      </span>`
    }
  ]
}
